import { render, staticRenderFns } from "./consent-bar.vue?vue&type=template&id=5697e82f&scoped=true&"
import script from "./consent-bar.vue?vue&type=script&lang=js&"
export * from "./consent-bar.vue?vue&type=script&lang=js&"
import style0 from "./consent-bar.vue?vue&type=style&index=0&id=5697e82f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697e82f",
  null
  
)

/* custom blocks */
import block0 from "./consent-bar.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/ui/icon.vue').default,UiButton: require('/app/components/ui/button.vue').default})
